export const COMPANY_MAIL = 'info@cytoalpha.hr';
export const COMPANY_TEL = '';
export const COMPANY_NAME = 'Cyto Alpha';
export const COMPANY_ADDRESS = 'Horvaćanska cesta 21';
export const COMPANY_TOWN = '10000 Zagreb';
export const COMPANY_DESC = 'za analizu svih vrsta citoloških uzoraka te citološke punkcije uz kontrolu UZV-a';
export const MAJA_TEL = '+385 98 1973 255';
export const LEILA_TEL = '+385 98 1856 056';
